import LogoZoom from '../../images/logo-technologies/logo-zoom.webp'
import LogoMailgun from '../../images/logo-technologies/logo-mailgun.webp'
import LogoStripe from '../../images/logo-technologies/logo-stripe.webp'
import LogoMailchimp from '../../images/logo-technologies/logo-mailchimp.webp'
import LogoTwilio from '../../images/logo-technologies/logo-twilio.webp'
import LogoMap from '../../images/logo-technologies/logo-maps.webp'
import LogoKlaviyo from '../../images/logo-technologies/logo-klaviyo.webp'


const Technologies = () => {
    return (
        <section className="technology-platform">
        
            <div className="technology-platform-wrapper">
                <h3>Technologies.</h3>
                <p>Embark on a journey through the cutting-edge technologies and platforms underpinning our services</p>
                
                <div className="technology-platform-logo-list">
                    <div className="tech-logo-item"> <img src={LogoZoom} alt="WooCommerce" loading='lazy'/> </div>
                    <div className="tech-logo-item"> <img src={LogoMailgun} alt="Logo Mailgun" loading='lazy'/> </div>
                    <div className="tech-logo-item"> <img src={LogoStripe} alt="Logo Stripe" loading='lazy'/> </div>
                    <div className="tech-logo-item"> <img src={LogoMailchimp} alt="Logo Mailchimp" loading='lazy'/> </div>
                    <div className="tech-logo-item"> <img src={LogoTwilio} alt="Logo Twilio" loading='lazy'/> </div>
                    <div className="tech-logo-item"> <img src={LogoMap} alt="Logo Map" loading='lazy'/> </div>
                    <div className="tech-logo-item"> <img src={LogoKlaviyo} alt="Logo Klaviyo" /> </div>
                </div>
            </div>
        </section>
    );
  }
  
  export default Technologies;